import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/service/api-service/api-service';

@Injectable({ providedIn: 'root' })
export class SocialMediaService {
  constructor(private api: ApiService) {}

  getSocialMedia(page: number, limit = 10, search = '', status = ''): Observable<any> {
    return this.api.post('/api/communication/social-media/list', {
      page,
      limit,
      search: search || null,
      status: status || null,
    });
  }

  getSocialMediaById(id: number): Observable<any> {
    return this.api.get(`/api/communication/social-media/${id}`);
  }

  createSocialMedia(data: any): Observable<any> {
    return this.api.post('/api/communication/social-media', data);
  }

  updateSocialMedia(id: number, data: any): Observable<any> {
    return this.api.put(`/api/communication/social-media/${id}`, data);
  }

  setStatus(id: number, status: 'ACTI' | 'INAC'): Observable<any> {
    return this.api.patch(`/api/communication/social-media/${id}/status`, { status });
  }

  deleteSocialMedia(id: number): Observable<any> {
    return this.api.delete(`/api/communication/social-media/${id}`);
  }
}
